
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { SaleAgreementModel } from 'models/generated/Entities.GormCrm.SaleAgreement';


const _gormCrm_SaleAgreementControllerHelper = new Map<string, Object>();
_gormCrm_SaleAgreementControllerHelper.set('GetCompanySaleAgreements', SaleAgreementModel);
_gormCrm_SaleAgreementControllerHelper.set('GetCompanySaleAgreementsForUser', SaleAgreementModel);


export const gormCrm_SaleAgreementControllerHelper = _gormCrm_SaleAgreementControllerHelper;

